import React, { useState } from 'react';
import api from '../services/api';
import { useNavigate, Link } from 'react-router-dom';

export default function Register() {
  const [form, setForm] = useState({username:'', email:'', password:'', is_public:true});
  const [error, setError] = useState('');
  const nav = useNavigate();

  const handle = e => setForm({ ...form, [e.target.name]: e.target.type==='checkbox' ? e.target.checked : e.target.value });

  const submit = async e => {
    e.preventDefault();
    try {
      await api.post('users/', form);
      nav('/login');
    } catch (err) {
	  console.log(err);
      setError('Registration failed');
    }
  };

  return (
    <form onSubmit={submit} style={{ maxWidth: 300, margin: '2rem auto' }}>
      <h2>Register</h2>
      {error && <p style={{color:'red'}}>{error}</p>}
      <div>
        <label>Username</label><br/>
        <input name="username" value={form.username} onChange={handle} required/>
      </div>
	   <div>
        <label>Email</label><br/>
        <input name="email" value={form.email} onChange={handle} required/>
      </div>
      <div>
        <label>Password</label><br/>
        <input type="password" name="password" value={form.password} onChange={handle} required/>
      </div>
      <div>
        <label>
          <input type="checkbox" name="is_public" checked={form.is_public} onChange={handle}/>
          Public Profile
        </label>
      </div>
      <button type="submit">Register</button>
      <p>
        Have an account? <Link to="/login">Login</Link>
      </p>
    </form>
  );
}